<!--The content below is only a placeholder and can be replaced.-->
<smart-app-banner *ngIf="curshowSmartBanner" (updateShowBanner)="updateShowBannerChange($event)"></smart-app-banner>
<app-header [showSmartBanner]='curshowSmartBanner' *ngIf="!isAppView" [ngStyle]="{display:pageName.indexOf('draft') == -1 || isMobile?'block':'none'}">
</app-header>

<div [ngClass]="{'draftPage':(pageName.indexOf('draft') > -1), 'noheaderExpand': (pageName.indexOf('draft') > -1 && isMobile),'mainContent':true,'mainContentMob':isMobile,'mainContentWithSAB':curshowSmartBanner}"
    (resized)="onResized($event)">
    <div class="row">
        <div class="col s12 m12">
            <router-outlet></router-outlet>
        </div>
        <!-- <app-activedraft *ngIf="isMobile == false"></app-activedraft>  -->
        <ngx-spinner bdOpacity=0.2 bdColor="rgba(51,51,51,0.25)" size="medium" color="#000000"
            type="ball-spin-clockwise-fade-rotating" fullScreen="true"></ngx-spinner>
    </div>
</div>